module.exports = __webpack_public_path__ + "15a8b21a695d79a0bfa552428b51221a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Digi/banner-mobile.jpg
// module id = 439
// module chunks = 12 13